// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__myFont_f401bb', '__myFont_Fallback_f401bb'"},"className":"__className_f401bb"};